<template>
  <div
    class="row d-flex justify-content-center align-items-center"
    style="height: 100vh"
  >
    <div class="col-lg-3 col-11">
      <div class="text-center">
        <img
          src="../assets/images/ZimScape-02.png"
          alt=""
          class="my-4"
          style="width: 200px"
        />
      </div>
      <p class="text-center mb-4 w-75 mx-auto">
        Sign in using your account email address
      </p>
      <a-form
        id="components-form-demo-normal-login"
        :form="form"
        class="login-form"
        @submit="handleSubmit"
      >
        <a-form-item
          :has-feedback="errors.username ? true : false"
          :validate-status="errors.username ? 'error' : ''"
          :help="errors.username ? errors.username : ''"
        >
          <a-input size="large" v-model="model.username" placeholder="Username">
            <a-icon
              slot="prefix"
              type="user"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input-password
            size="large"
            v-model="model.password"
            type="password"
            placeholder="Password"
          >
            <a-icon
              slot="prefix"
              type="lock"
              style="color: rgba(0, 0, 0, 0.25)"
            />
          </a-input-password>
        </a-form-item>
        <a-form-item class="mb-2">
          <a-button
            size="large"
            type="primary"
            html-type="submit"
            class="login-form-button"
            :loading="hasOps()"
          >
            Log in
          </a-button>
        </a-form-item>
        <div class="row">
          <div class="col-6">
            Or
            <router-link to="/register" class="login-form-forgot" href="">
              Register
            </router-link>
          </div>
          <div class="col-6 text-right">
            <router-link to="/reset" class="login-form-forgot" href="">
              Forgot password
            </router-link>
          </div>
        </div>
        <Footer></Footer>
      </a-form>
    </div>

    <a-modal
      title="Set New Password"
      :visible="visible"
      :confirm-loading="hasOps()"
      @ok="updatePassword"
      @cancel="handleCancel"
    >
      <p>
        We've detected an auto-generated password. Please enter a new password.
      </p>
      <a-input-password
        size="large"
        v-model="resetModel.password"
        placeholder="New Password"
      >
        <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
      </a-input-password>
    </a-modal>
  </div>
</template>

<script>
import baseMethods from "../utils/baseMethods";
import { URLS } from "@/utils/constants";
import Footer from "@/components/Footer";
import { utils } from "@/utils/utils";
// import { Notify } from "@/utils/notifications";

export default {
  name: "Login",
  data() {
    return {
      errors: {},
      model: {
        username: "",
        password: "",
      },
      resetModel: {
        password: "",
      },
      visible: false,
      confirmLoading: false,
      operations: 0,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  components: {
    Footer,
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    updatePassword() {
      this.post(
        URLS.reset,
        this.resetModel,
        "Password reset successful",
        null,
        true
      ).then((res) => {
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);

        this.$router.push("/users");
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.visible = false;
    },

    handleSubmit(e) {
      e.preventDefault();

      this.postNoAuth(
        URLS.login,
        this.model,
        "Login successful",
        null,
        true
      ).then((res) => {
        if (!res) return;
        if (res.errors) return (this.errors = res.errors);

        localStorage.setItem("access_token", res.accessToken);

        this.checkReset();
      });
    },

    checkReset() {
      this.get(`${URLS.userByEmail}/${this.model.username}`, true).then(
        (res) => {
          if (!res) return;
          if (res.errors) return (this.errors = res.errors);

          // save profile to disk
          utils.save("user_profile", res.body);
          // if requires reset then do that instead of moving to home page
          if (res.body.requiresReset) this.showModal();
          else this.$router.push("/users");
        }
      );
    },

    ...baseMethods,
  },
};
</script>
